
import TableList from "@components/templates/tablelist";
import { HttpBillorgList, HttpDeleteBillorgOne } from "@/service/newbigaccount";
import { mapState, mapGetters } from "vuex";
import compadd from "./add.vue";
import mixin from '../minxin';
export default {
    mixins: [TableList,mixin],
    components:{
        compadd
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                    EQ_expenseCategoryType:null
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename:'',
            datetime:'',
            Plugins: {show: true},
            initData:'',
            TreeSearchs:{
                show:true,
                data: [{
                    label: "全部",
                    key:'EQ_expenseCategoryType',
                    value: null
                }, {
                    label: "仓储费",
                    key: "EQ_expenseCategoryType",
                    value: '1'
                },{
                    label: "作业费",
                    key: "EQ_expenseCategoryType",
                    value: '0'
                },
                // {
                //     label: "快递费",
                //     key: "EQ_expenseCategoryType",
                //     value: '2'
                // },
                {
                    label: "增值服务费",
                    key: "EQ_expenseCategoryType",
                    value: '3'
                },
                // {
                //     label: "包材费",
                //     key: "EQ_expenseCategoryType",
                //     value: '4'
                // }
            ]
            },
        };
    },
    methods: {
        ajaxRequest: HttpBillorgList,

        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.operate = {
                        title: '添加',
                        show:true,
                        width:1000,
                        component: "compadd",
                        activeids:params,
                        orglist:this.getBillcusorgList,
                        billtypelist:this.getCusBillTypeList,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "edit":
                    this.$router.push({
                        name: 'promotionUpdate',
                        params: { type: "edit"},
                        query: { id: params , sourceType: this.formData.search.EQ_type },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "delete":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{id:params},
                        title: "删除操作",
                        ajaxRequest:HttpDeleteBillorgOne
                    }
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id } = row
            return [{
                label:'删除',
                show: true,
                params:id,
                operate:'delete'
            }, ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCusBillTypeList']),
        ToolsData(){
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
            ]

        },
        SearchsData() {
            const dropStyle="width:auto;";
            return  [

                {
                    label: "客户组织",
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    show:true,
                    options:this.getBillcusorgList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: '费用类型',
                    tag: 'vSelect',
                    key: 'EQ_expenseCategoryType',
                    options: this.getCusBillTypeList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: '费用类型代码',
                    tag: 'vInput',
                    key: 'CN_expenseCategoryCustomizeCode',
                    show: true,
                },
                {
                    label: '订单类型',
                    tag: 'vSelect',
                    key: 'CN_expenseCategoryCustomize.orderType',
                    options:this.getOrderList,
                    props:{
                        filterable:true,
                    },
                },
                {
                    label: '创建时间',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                }
            ]
        },
        columns() {
            return  [
                {
                    show:false,
                    type: 'selection',
                    width: 60,
                    align: 'center',
                    formName: 'id'
                },{
                    title: '操作',
                    width: 90,
                    render:this.getOperateNodes,
                },
                {
                    title: '费用类型',
                    key: 'expenseCategoryType',
                    render: (h, { row }) => this.findRenderLabel(this.getCusBillTypeList, row.expenseCategoryType),
                },
                {
                    title: '费用类型代码',
                    key: 'expenseCategoryCustomizeCode',
                },
                {
                    title: '订单类型',
                    key: 'orderType',
                    render: (h, { row }) => {
                        // console.log('orderType', row.orderType)
                        if (!row.expenseCategoryCustomize.orderType || row.expenseCategoryCustomize.orderType == 0) return <div>--</div>
                        let textArr = row.expenseCategoryCustomize.orderType.split(',').map(value => {
                            return this.getOrderList.filter(item => {
                                return item.value == value
                            })[0].label;
                        });
                        return textArr.join(',');
                    }
                },
                {
                    title: '客户组织',
                    render: (h, { row }) => this.findRenderLabel(this.getBillcusorgList, row.organizationId),
                },
                {
                    title: '创建人',
                    render: (h, { row }) => {
                        return <div>
                        <div>{row.createdName || '--'}</div>
                        </div>

                    },
                },{
                    title: '创建时间',
                    key:'createdAt'
                },
            ];
        },

    },

};
